import {
  Button,
  Card,
  Form,
  Input,
  message,
  Select,
  Upload,
  App,
  Row,
  Col,
} from "antd";
import { useEffect, useState } from "react";
import {
  VIEW_GAME,
  EDIT_GAME_VIEW,
} from "../../apis/apis";
import { useNavigate, useParams } from "react-router-dom";
import {
  LeftOutlined,
  Loading3QuartersOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import CustomRichTextEditor from "../../components/CustomTextEditor";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import ScormUploader from "../../components/ScromUploader";

export default function EditGame() {
  const { notification } = App.useApp();

  const navigate = useNavigate();

  const { id } = useParams();

  const [form] = Form.useForm();

  const [pageLoader, setPageLoader] = useState(true);

  const [loading, setLoading] = useState(false);

  const [thumbnail, set_thumbnail] = useState("");

  const [thumbnail_api, set_thumbnail_api] = useState("");

  const [title, set_title] = useState("");

  const [tag, set_tag] = useState([]);

  const [description, set_description] = useState("");

  const [scorm_file, set_scorm_file] = useState("");

  const [errors, set_errors] = useState("");

  const [thumbnailError, setthumbnailError] = useState("");

  const [scormUploading, setScormUploading] = useState(false);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();

    reader.addEventListener("load", () => callback(reader.result));

    reader.readAsDataURL(img);
  };

  const uploadButton = (
    <button
      type="button"
      style={{
        border: 0,
        background: "none",
      }}
    >
      {loading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined />
      )}

      <div style={{ marginTop: 8 }}>
        Upload
      </div>
    </button>
  );

  useEffect(() => {
  const VIEW_API = async () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", atob(id));

    try {
      const response = await VIEW_GAME(FORM_DATA);

      console.log(response.data);

      if (response?.data?.status) {
        const data = response.data.data;

        set_title(data?.title || "");
        set_description(data?.description || "");
        set_scorm_file(data?.scorm_file || "");
        set_thumbnail(data?.thumbnail || "");

        set_tag(
          Array.isArray(data?.tag)
            ? data.tag
            : data?.tag
            ? data.tag.split(",")
            : []
        );
      }
    } catch (err) {
      console.log(err);
    }

    setPageLoader(false);
  };

  VIEW_API();
}, [id]);

  const onFinish = async () => {
    if (scormUploading) return;

    setLoading(true);

    const FORM_DATA = new FormData();

    FORM_DATA.append("id", atob(id));

    FORM_DATA.append("thumbnail", thumbnail_api);

    FORM_DATA.append("title", title);

    FORM_DATA.append("tag", tag);

    FORM_DATA.append("description", description);

    FORM_DATA.append("scorm_file", scorm_file);

    try {
      const response = await EDIT_GAME_VIEW(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response.data.message,
        });

        navigate("/games");
      } else {
        setLoading(false);

        set_errors(response?.data?.errors);
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Server Error"
      );
    }
  };

  return (
    <div className="lms-body">
      <Card>

        {pageLoader ? (
          <CulsightPageLoader />
        ) : (
          <>
            <Row>

              <Col span={12}>

                <h2>

                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/games")}
                  >

                    <LeftOutlined />

                  </span>

                  {" "}Game Details

                </h2>

              </Col>

            </Row>

            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
            >

              <Form.Item label="Upload Game Photo">

                <Upload
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => {

                    const isImage =
                      file.type === "image/jpeg" ||
                      file.type === "image/png" ||
                      file.type === "image/jpg";

                    const isLt512KB =
                      file.size <= 512 * 1024;

                    if (!isImage) {
                      setthumbnailError(
                        "Only JPG/PNG allowed."
                      );
                      return false;
                    }

                    if (!isLt512KB) {
                      setthumbnailError(
                        "Image must be under 512 KB."
                      );
                      return false;
                    }

                    const img = new Image();

                    img.src = URL.createObjectURL(file);

                    img.onload = () => {

                      if (
                        img.width === 490 &&
                        img.height === 320
                      ) {

                        setthumbnailError("");

                        getBase64(file, (url) =>
                          set_thumbnail(url)
                        );

                        set_thumbnail_api(file);

                      } else {

                        setthumbnailError(
                          "Image must be 490 x 320."
                        );

                      }

                    };

                    return false;
                  }}
                >

                  {thumbnail ? (
                    <img
                      src={thumbnail}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}

                </Upload>

                {thumbnailError && (
                  <span style={{ color: "red" }}>
                    {thumbnailError}
                  </span>
                )}

              </Form.Item>

              <Form.Item label="Title">

                <Input
                  value={title}
                  onChange={(e) =>
                    set_title(e.target.value)
                  }
                />

                {errors?.title && (
                  <span style={{ color: "red" }}>
                    {errors.title}
                  </span>
                )}

              </Form.Item>

              <Form.Item label="Tag">

                <Select
                  mode="tags"
                  value={tag}
                  onChange={set_tag}
                />

                {errors?.tag && (
                  <span style={{ color: "red" }}>
                    {errors.tag}
                  </span>
                )}

              </Form.Item>

              <Form.Item>

                <CustomRichTextEditor
                  editorLabel="Description"
                  value={description}
                  onChange={set_description}
                />

              </Form.Item>

              <Form.Item label="SCORM Package">

                {scorm_file && (
                  <div
                    style={{
                      marginBottom: 15,
                      color: "#1677ff",
                    }}
                  >
                    Current File:
                    <br />
                    {scorm_file}
                  </div>
                )}

                <ScormUploader
                  set_fileKey={set_scorm_file}
                  onUploadStart={() =>
                    setScormUploading(true)
                  }
                  onUploadComplete={() =>
                    setScormUploading(false)
                  }
                />

              </Form.Item>

              <Form.Item>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading || scormUploading}
                  disabled={loading || scormUploading}
                  style={{ float: "right" }}
                >

                  Save

                </Button>

              </Form.Item>

            </Form>

          </>
        )}
      </Card>
    </div>
  );
}